module.exports = __webpack_public_path__ + "static/media/menu_icon_locomo_hover.04c8d9f8.png";